import React, { useCallback } from 'react';
import type { User } from '#/graphql/types';
import { useNavigate } from 'react-router-dom';
import List from '#/common/components/List';
import { gql } from '@apollo/client';
import { getUserList } from '#/graphql/queries';
import columns from '../UserDataGrid/columns';
import formatRoleText from '#/common/utils/formatters/formatRoleText';
import { Filter } from '#/common/components/DataGrid';

const getUserListQuery = gql(getUserList);
export interface UserListProps {
  permanentFilters?: Filter[];
}

const UserList: React.FC<UserListProps> = (props) => {
  const { permanentFilters } = props;

  const navigate = useNavigate();

  const openUser = useCallback(
    (user: User) => {
      navigate(`/admin/users/${user.id}`);
    },
    [navigate],
  );

  return (
    <List<User>
      titleKey="name"
      onClick={openUser}
      getItemsQuery={getUserListQuery}
      permanentFilters={permanentFilters}
      bodyFields={[
        {
          key: (item: User) => formatRoleText(item.role),
          label: 'Role',
        },
        { key: 'email', label: 'Email' },
      ]}
      columnList={columns}
    />
  );
};

export default React.memo(UserList);
